/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".selected-view[_ngcontent-%COMP%]{color:#45aaf2;border-bottom:1px solid #45aaf2;padding-bottom:12px}.margin-right-44[_ngcontent-%COMP%]{margin-right:44px}.margin-left-34[_ngcontent-%COMP%]{margin-left:34px}.select-tabs[_ngcontent-%COMP%]{color:#495057;font-size:18px}.align-icons[_ngcontent-%COMP%]{align-items:center;font-size:15px}\n/*# sourceMappingURL=captain-incentive-progress.component.css.map*/"];
export { styles as styles };
